// app/src/api/visitrouteApi.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { MemberListResponse, MemberSerializer } from "@/types/member"
import { VisitrouteSerializer } from "@/types/visitroute"
import { CommonResponse, CommonTResponse, CommonReferenceResponse } from "@/types/common"
import { serverApi, getAuthHeaders, handleApiResponse, queApi, handleReferenceResponse } from "@core/api/core"

// 서버에 차트 관리자 설치 여부를 확인하는 API 응답 타입
export interface InstalledResponse {
  message: string
  result: boolean
}

// ──────────────────────────────────────────────────────────────────────────────
// 사용자 목록 조회 응답 타입
export const getVisitroutes = async (): Promise<VisitrouteSerializer[]> => {
  const requestUrl = `/visitroute/`
  const response = await serverApi.get<CommonTResponse<VisitrouteSerializer>>(requestUrl)
  return handleApiResponse<VisitrouteSerializer[]>(response)
}

// ──────────────────────────────────────────────────────────────────────────────
// 생성
export const createVisitroute = async (payload: VisitrouteSerializer): Promise<boolean> => {
  const requestUrl = `/visitroute/`
  const response = await serverApi.post<CommonResponse>(requestUrl, payload)
  return handleApiResponse<boolean>(response)
}

// ──────────────────────────────────────────────────────────────────────────────
// 수정
export const updateVisitroute = async (payload: VisitrouteSerializer): Promise<boolean> => {
  const requestUrl = `/visitroute/${payload.visitrouteUuid}/`
  const response = await serverApi.patch<CommonResponse>(requestUrl, payload)
  return handleApiResponse<boolean>(response)
}

// ──────────────────────────────────────────────────────────────────────────────
// 삭제
export const deleteVisitroute = async (uuid: string): Promise<boolean> => {
  const requestUrl = `/visitroute/${uuid}/`
  const response = await serverApi.delete<CommonResponse>(requestUrl)
  return handleApiResponse<boolean>(response)
}

// ──────────────────────────────────────────────────────────────────────────────

export const fetchVisitrouts = createAsyncThunk<
  VisitrouteSerializer[], // 성공 시 반환할 타입
  void, // 인자로 받을 객체 타입
  { rejectValue: string }
>("visitroute/fetchVisitrouts", async (_, { rejectWithValue }) => {
  try {
    // console.debug("fetchVisitrouts 시작")
    const requestUrl = `/reference/visitroute/`
    const response = await queApi.get<CommonReferenceResponse>(requestUrl)
    // console.debug("fetchVisitrouts 응답", response)

    const { columns, results } = handleReferenceResponse(response)

    const datas: VisitrouteSerializer[] = results.map(row => {
      // columns[i] ↔ row[i] 매핑
      const obj = Object.fromEntries(columns.map((col, i) => [col, row[i]])) as Record<string, number | string>

      return {
        visitrouteUuid: String(obj["visitrouteUuid"]),
        visitrouteName: String(obj["visitrouteName"]),
      }
    })
    return datas
  } catch (error: any) {
    return rejectWithValue(error.message || "방문 경로 조회 중 오류가 발생했습니다.")
  }
})
